import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { filterBuilder, getBoundaryCoordinates } from '@ha/algolia';
import { Thunk } from 'ha/myredux/types';
import { GlobalState } from 'ha/types/store';
import reportError from 'ha/helpers/bugsnag/reportError';
import { City } from 'ha/services/apiV2/types';

import { CityListingsCountsMap } from '../types';

export enum ActionTypes {
  START = '[Home] LOAD_COUNTS',
  DONE = '[Home] LOAD_COUNTS_DONE',
  FAIL = '[Home] LOAD_COUNTS_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (counts: CityListingsCountsMap) =>
    createAction(ActionTypes.DONE, counts),
  fail: () => createAction(ActionTypes.FAIL),
};

export type ActionsUnionType = ActionsUnion<typeof Actions>;

type GetCounts = (cities: City[]) => Thunk<GlobalState>;

const queryFilterBuilder = filterBuilder();

const getCounts: GetCounts =
  cities =>
  async (dispatch, _, { algolia }) => {
    dispatch(Actions.start());

    const queries = cities.map(({ latitude, longitude, mapRadius }) => ({
      query: '',
      params: {
        distinct: true,
        insideBoundingBox: [
          getBoundaryCoordinates(latitude, longitude, mapRadius / 1000),
        ],
        responseFields: ['nbHits'],
        filters: queryFilterBuilder({}),
      },
    }));

    return algolia
      .searchListings(queries)
      .then(({ results }) => {
        const listingsCount = results.reduce(
          (result: CityListingsCountsMap, { nbHits }, index: number) => {
            const { cityCanonical } = cities[index];

            if (cityCanonical) {
              result[cityCanonical] = nbHits;
            }

            return result;
          },
          {},
        );

        return dispatch(Actions.done(listingsCount));
      })
      .catch(err => {
        reportError('request getCounts failed', { metaData: err });

        return dispatch(Actions.fail());
      });
  };

export default getCounts;
